import { alpha } from '@mui/material'

import makePalette, { white } from './util'

/**
 * Raised surfaces (cards, nav, menus). Same role as night's `#141414`, shifted
 * into navy so the whole chrome reads blue instead of charcoal.
 */
const surface = '#141C2E'

/**
 * Kinda Blue: dark-blue counterpart to night — same two-tone structure (canvas
 * vs surface) but every gray is a navy. `palette.mode` stays `dark` so
 * existing light/dark branches (maps, charts, banners) keep working.
 */
export default makePalette({
  action: {
    color: white,
    opacities: {
      active: 0.54,
      hover: 0.06,
      selected: 0.12,
      disabled: 0.3,
      focus: 0.12
    }
  },

  palette: {
    mode: 'dark',

    text: {
      primary: '#E8EEF7',
      secondary: alpha(white, 0.62),
      disabled: alpha(white, 0.4)
    },

    background: {
      layout: '#0A1220',
      default: '#0D1726',
      paper: surface,
      navCard: surface
    },

    divider: '#243352',

    customColors: {
      main: '#DCE4F0',
      trackBg: '#243352',
      tableHeaderBg: '#10182A'
    }
  }
})
